export { default } from './StatisticsWidget.js';
